/**
 * Text content lives in `/content` as real markdown/txt files so it can be
 * edited without touching any code. Vite inlines them as raw strings at build
 * time, lazily, so each document is its own tiny chunk.
 */
const modules = import.meta.glob('/content/**/*.{md,txt}', {
  query: '?raw',
  import: 'default',
}) as Record<string, () => Promise<string>>;

/** `about.md` → `/content/about.md` */
function keyFor(src: string): string {
  const clean = src.replace(/^\/?content\//, '').replace(/^\//, '');
  return `/content/${clean}`;
}

export function hasContent(src: string): boolean {
  return keyFor(src) in modules;
}

export async function readContent(src: string): Promise<string> {
  const loader = modules[keyFor(src)];
  if (!loader) {
    return `The file "${src}" could not be found.\r\n\r\nIt may have been moved or deleted.`;
  }
  try {
    return await loader();
  } catch {
    return `The file "${src}" could not be read.`;
  }
}

export function contentKeys(): string[] {
  return Object.keys(modules).map((k) => k.replace('/content/', ''));
}
